import { mapHelper } from "@/utils/utils.js";
//评价状态
const isCommentStatus = [
  {
    value: 1,
    text: "非常差",
  },
  {
    value: 2,
    text: "差",
  },
  {
    value: 3,
    text: "一般",
  },
  {
    value: 4,
    text: "满意",
  },
  {
    value: 5,
    text: "非常满意",
  },
];

const { map: isCommentStatusMap, setOps: isCommentStatusOps } =
  mapHelper.setMap(isCommentStatus);
const activityStatus = [
  {
    key: 1,
    value: "报名未开始",
  },
  {
    key: 2,
    value: "报名进行中",
  },
  {
    key: 3,
    value: "活动未开始",
  },
  {
    key: 4,
    value: "活动进行中",
  },
  {
    key: 5,
    value: "活动结束",
  },
  {
    key: 6,
    value: "活动取消",
  },
];

export { isCommentStatus, isCommentStatusMap, activityStatus };
